import { DEFAULT_API } from "../utils/variables";
import { useTranslation } from "react-i18next";

export const fetchRegisterUser = async (
  formLogin,
  contactCode,
  category,
  describe,
  language = 'en',
  latLong
) => {
  const fullName = formLogin.first_last_name.trim();
  let firstName = "";
  let lastName = "";

  if (fullName.includes(' ')) {
    const nameParts = fullName.split(' ');
    firstName = nameParts[0];
    // Join all remaining parts as the last name
    lastName = nameParts.slice(1).join(' ');
  } else {
    // Handle case where only one name is provided
    firstName = fullName;
    lastName = ""; // Or set a default
  }

  const formdata = new FormData();
  formdata.append("username", formLogin.username.toLocaleLowerCase());
  formdata.append("email", formLogin.email.toLocaleLowerCase());
  formdata.append("password", formLogin.password);
  formdata.append("c_password", formLogin.c_password);
  formdata.append("service_type", JSON.stringify(describe));
  formdata.append("first_name", firstName);
  formdata.append("last_name", lastName);
  formdata.append("dob", formLogin.dob);
  formdata.append("phone", formLogin.phone || '111');
  formdata.append("address", formLogin.address);
  formdata.append("zip", formLogin.zip);
  formdata.append("hearAboutUs", formLogin.hearAboutUs);
  formdata.append("user_type", category);
  formdata.append("lat", latLong.lat || 0);
  formdata.append("lng", latLong.lng || 0);
  if (formLogin.city) {
    formdata.append("city", formLogin.city);
  }

  if (formLogin.country) {
    formdata.append("country", formLogin.country);
  }
  formdata.append(
    "referralId",
    "eyJpdiI6IlNaODJ2dG1hOEsrbVdjdDhHR1BhY1E9PSIsInZhbHVlIjoicE1yVVpyeWNNZ1VxYkY5cDJJNjJZUT09IiwibWFjIjoiYTc5ODdjZDM1NTc2N2MxMzY2NjEzZTRkMDlkZTZmM2Y4N2M2NGE3YmJhY2Q5YjA0YmFhNDRhODE0ZWM1OThjMSJ9"
  );

  formdata.append('lang', localStorage.getItem("language"));
  const requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
  };

  try {
    console.error('body: ', requestOptions);
    const response = await fetch(`${DEFAULT_API}/api/register`, requestOptions);
    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || "Something went wrong");
    }
    return response.json();
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};
